import React from 'react';
import LinkGrid from 'shared/components/data-display/LinkGrid';
import { CardSection } from 'shared/components/cardControls';
import { getBuildingToolsPath, tenantRadiusSearchPath } from 'shared/routes/networking';

/**
 * @param {Object<string, *>} buildingState - The building state object containing
 * data and permissions
 */
export default function BuildingNetworkingLinks({ buildingState }) {
  const descriptions = [];

  if (buildingState.canAccessNetworking) {
    descriptions.push({
      title: 'Networking',
      links: [{
        link: getBuildingToolsPath([buildingState.data.id]),
        text: `Building Tools - ${buildingState.data.name}`,
      }, {
        link: `${tenantRadiusSearchPath}?building_id=${buildingState.data.id}`,
        text: `Radius Records - ${buildingState.data.name}`,
      }],
    });
  }

  return (
    <CardSection>
      <LinkGrid descriptions={descriptions} />
    </CardSection>
  );
}
